<div *ngIf="!showContent" class="loading-spinner">
    <mat-spinner></mat-spinner>
</div>

<ng-container *ngIf="showContent">

    <app-menu>
        <div class="form-container">
            <div class="step-content">
                <!-- Progress Bar above each step of form to detail which step is active-->
                <ul class="progress-bar">
                    <li [class.active]="step === 1" (click)="changeStep(1)">
                        <span class="icon"><i class="fas fa-person"></i></span>
                        <br>
                        <span class="label">Contacts</span>
                    </li>
                    <li [class.active]="step === 2" (click)="changeStep(2)">
                        <span class="icon"><i class="fas fa-dollar-sign"></i></span>
                        <br>
                        <span class="label">Banking Information</span>
                    </li>
                    <li [class.active]="step === 3" (click)="changeStep(3)">
                        <span class="icon"><i class="fas fa-house"></i></span>
                        <br>
                        <span class="label">Address</span>
                    </li>
                </ul>

                <!-- Contacts Form -->
                <div *ngIf="step === 1">
                    <form [formGroup]="contactForm">
                        <mat-card class="card">
                            <mat-card-header class="contact-form-header">
                                <mat-card-title>
                                    Client Details
                                </mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="contact-form-details">
                                    <mat-form-field class="input-container">
                                        <mat-label>Client Name</mat-label>
                                        <input matInput placeholder="Input Client Name"  formControlName="clientname" required>
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Factoring For</mat-label>
                                        <input matInput placeholder="Input Company Name" formControlName="factoringfor">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Client Number</mat-label>
                                        <input matInput placeholder="Input Client Number" formControlName="clientnumber">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Short Name</mat-label>
                                        <input matInput placeholder="Input Short Name" formControlName="clientshortname">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Client Description</mat-label>
                                        <input matInput placeholder="Input Description" formControlName="cliententrydescription">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Group Name</mat-label>
                                        <input matInput placeholder="Input Group name" formControlName="groupname">
                                    </mat-form-field>           
                                    <mat-form-field class="input-container">
                                        <mat-label>Transaction Code</mat-label>
                                        <input matInput placeholder="Input Transaction Code" formControlName="clienttransactioncode">
                                    </mat-form-field>                                                                  
                                </div>
                            </mat-card-content>
                        </mat-card>
                        <div class="form-actions-container">
                            <div class="form-actions">
                                <button mat-raised-button color="primary" (click)="prevStep()">Back</button>
                                <button mat-raised-button color="primary" (click)="nextStep()">Next</button>
                            </div>
                        </div>
                    </form>
                </div>
                <div *ngIf="step === 2">
                    <form [formGroup]="bankingInfoForm">
                        <mat-card class="card">
                            <mat-card-header class="financial-form-header">
                                <mat-card-title>
                                    Banking Information
                                </mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="load-form-details-pickup">
                                    <mat-form-field class="input-container">
                                        <mat-label>Bank Number</mat-label>
                                        <input matInput placeholder="Input Bank No." formControlName="clientbankno">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Branch Number</mat-label>
                                        <input matInput placeholder="Input Branch No." formControlName="clientbranchno">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>ABA Routing Number</mat-label>
                                        <input matInput placeholder="Input Routing NO." formControlName="clientabaroutingno">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Account Number</mat-label>
                                        <input matInput placeholder="Input Account NO." formControlName="clientaccountno">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Currency</mat-label>
                                        <mat-select formControlName="clientcurrency" required>
                                            <mat-option value='CAD'>CAD</mat-option>
                                            <mat-option value='USD'>USD</mat-option>
                                        </mat-select>                                        
                                    </mat-form-field>
                                </div>
                            </mat-card-content>
                        </mat-card>
                        <div class="form-actions-container">
                            <div class="form-actions">
                                <button mat-raised-button color="primary" (click)="prevStep()">Back</button>
                                <button mat-raised-button color="primary" (click)="nextStep()">Next</button>
                            </div>
                        </div>
                    </form>
                </div>
                <div *ngIf="step === 3">
                    <form [formGroup]="addressForm">
                        <mat-card class="card">
                            <mat-card-header class="address-form-header">
                                <mat-card-title>
                                    Address
                                </mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="appointment-form-details-pickup">
                                    <mat-form-field class="input-container">
                                        <mat-label>Address</mat-label>
                                        <input matInput placeholder="Input Address" formControlName="clientaddress">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>City</mat-label>
                                        <input matInput placeholder="Input City" formControlName="client_locality">
                                    </mat-form-field>      
                                    <mat-form-field class="input-container">
                                        <mat-label>Province/State</mat-label>
                                        <input matInput placeholder="Input Province/State" formControlName="client_region">
                                    </mat-form-field>         
                                    <mat-form-field class="input-container">
                                        <mat-label>Postal Code</mat-label>
                                        <input matInput placeholder="Input Postal Code" formControlName="client_postal_code">
                                    </mat-form-field>                                                                      
                                    <mat-form-field class="input-container">
                                        <mat-label>Country</mat-label>
                                        <mat-select formControlName="client_country">
                                            <mat-option value='CA'>CA</mat-option>
                                            <mat-option value='US'>US</mat-option>
                                        </mat-select>   
                                    </mat-form-field>                                                                     
                                </div>
                            </mat-card-content>
                        </mat-card>
                        <div class="form-actions-container">
                            <div class="form-actions">
                                <button mat-raised-button color="primary" (click)="prevStep()">Back</button>
                                <button mat-raised-button color="primary" (click)="submit()">submit</button>
                            </div>
                        </div>
                        <div *ngIf="isLoading" class="spinner">
                            <mat-spinner></mat-spinner>
                          </div>
                    </form>
                </div>
            </div>
        </div>
    </app-menu>
</ng-container>